import { useEffect, useState } from "react";
import styled from "styled-components";
import { cartService } from "../../service/CartService";
import { productService } from "../../service/ProductService";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import LoadingAnimation from "../animation/LoadingAnimation";
import OutlinedPicker from "../picker/OutlinedPicker";

const Wrapper = styled.div`
  display: flex;
  gap: 50px;
  font-weight: 350;
  @media (max-width: 500px) {
    gap: 20px;
  }
`;
const Image = styled.div`
  img {
    height: 240px;
    width: 175px;
    object-fit: cover;
  }
`;
const Space = styled.div`
  height: 20px;
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  h2 {
    font-size: ${fontSize.l};
    text-align: left !important;
  }
  span {
    font-size: ${fontSize.s};
    color: ${colors.textMuted};
  }
  h3 {
    font-size: ${fontSize.xs};
    color: ${colors.black};
  }
`;
const Picker = styled.div`
  margin: 10px 0px;
  display: flex;
  gap: 5px;
`;
const QuantityPicker = styled.div``;
const RemoveButton = styled.span`
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  transition-duration: 0.2s;
  &:hover {
    color: ${colors.black};
  }
`;
function ProductCartCard({ cart, triggerRebuildParent }) {
  const [product, setProduct] = useState();
  const [quantity, setQuantity] = useState(cart.quantity);
  const [loading, setLoading] = useState();

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      productService.getProductById(
        cart.productId,
        (res) => {
          setProduct(res);
          setLoading(false);
        },
        {
          default: (message) => {
            alert(message);
          },
        }
      );
    };
    fetchProduct();
  }, []);

  const handleRemoveCartItem = () => {
    cartService.removeFromCart(cart.id);
    triggerRebuildParent(true);
  };

  const handleChangeQuantity = (newQuantity) => {
    setQuantity(newQuantity);
    cartService.updateQuantity(cart, newQuantity).then(() => {
      triggerRebuildParent(true);
    });
  };
  return (
    <Wrapper>
      {loading && <LoadingAnimation />}
      {product && (
        <>
          <Image>
            <img
              src={
                process.env.REACT_APP_IMAGE_BASE_URL + product.images[0].path
              }
              alt="cloth"
            />
          </Image>
          <Details>
            <h2>{product.name}</h2>
            <span>Cart Code: {cart.id}</span>
            <Space />
            <h3>
              Color: <b>{cart.color}</b>
            </h3>
            <h3>
              Size: <b>{cart.size}</b>
            </h3>
            <h3>
              price: <b>{product.price * quantity}</b>
            </h3>
            <QuantityPicker>
              <h3>Quantity: </h3>
              <Picker>
                <OutlinedPicker
                  text="-"
                  onClick={() => {
                    quantity > 1 && handleChangeQuantity(quantity - 1);
                  }}
                />
                <OutlinedPicker text={quantity} />
                <OutlinedPicker
                  text="+"
                  onClick={() => {
                    quantity < 5 && handleChangeQuantity(quantity + 1);
                  }}
                />
              </Picker>
              <RemoveButton
                onClick={() => {
                  handleRemoveCartItem();
                }}
              >
                Remove
              </RemoveButton>
            </QuantityPicker>
          </Details>
        </>
      )}
    </Wrapper>
  );
}

export default ProductCartCard;
